import { GetServerSideProps } from 'next'

import { withAuthenGuard } from '@lib/hoc/withAuthenGuard'
import { ChapterPage } from '@features/myWriting/pages/ChapterPage'
import { WithChapterPageProps } from '@features/myWriting/pages/ChapterPage/interface'
import { AppLayout } from '@components/layouts/AppLayout'
import { isMaintenanceHandler } from '@lib/maintenanceHandler'

function ChapterPreview(props: WithChapterPageProps) {
  return (
    <AppLayout>
      <ChapterPage {...props} />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const isMaintenance = await isMaintenanceHandler()
  if (isMaintenance) {
    return {
      redirect: {
        destination: '/maintenance',
        permanent: false,
      },
      props: {
        isMaintenance: !!isMaintenance,
      },
    }
  }

  if (params?.chapterId && params?.id) {
    const chapterId = Number(params.chapterId)
    return {
      props: {
        key: `my-chapter-${chapterId}`,
        bookId: Number(params.id),
        chapterId,
        isMaintenance: false,
      },
    }
  }

  return {
    redirect: {
      destination: '/my-writing',
      permanent: false,
      isMaintenance: false,
    },
  }
}

export default withAuthenGuard(ChapterPreview)
